import React from 'react';

import { default as SettingsNotifications } from '../../components/Settings/Notifications'

import MainBlockHeader from '../MainBlockHeader'
import MainBlockContainer from '../MainBlockContainer';
import { useTranslation } from 'react-i18next';

export default function Notifications() {
  //let { userUid } = useParams();
  const { t } = useTranslation();

  return (
    <>
      <MainBlockHeader header={t('settingsNotifications.pageTitile')} >
      </MainBlockHeader>

      <MainBlockContainer>
        <SettingsNotifications />
      </MainBlockContainer>
    </>
  );
}

